@if (subnavItems.length > 1) {
  <motn-subnav
    [items]="subnavItems"
  ></motn-subnav>
}

<router-outlet></router-outlet>
